import React, { useEffect, useState } from 'react';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Box, Checkbox, Table } from '@mui/material';
import SmsIcon from '@mui/icons-material/Sms';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {
  ActionMenuItem,
  ContextMenuPosition,
  Drive,
} from '../../../models/interfaces';
import SelectMenu from '../SelectMenu';
import ContextMenu from '../ContextMenu';
import Loading from '../Loading';
import ShareIcon from '@mui/icons-material/Share';
import ShareModal from '../home/ShareModal';
import EditIcon from '@mui/icons-material/Edit';
import TitleUpdateDialog from '../TitleUpdateDialog';
import { SHARE_PERM_DROPDOWN } from 'utils/constants';

interface IProps {
  dataSource: Drive[];
  handleRowClick: (id: string) => void;
  selectedIds: string[];
  loading?: boolean;
  handleCheckBoxChange: (id: string) => void;
  handleMenuClick: (id: string) => void;
  handUpdateTitleChat: (id: string, title: string) => void;
  handleContextMenuClick: () => void;
}

export default function TableListChat(props: IProps) {
  const {
    dataSource,
    handleRowClick,
    handleCheckBoxChange,
    selectedIds,
    handleMenuClick,
    loading,
    handUpdateTitleChat,
    handleContextMenuClick,
  } = props;
  const [contextMenuRow, setContextMenuRow] =
    useState<ContextMenuPosition | null>(null);
  const [selectedIdContexMenu, setSelectedIdContexMenu] = useState<
    string | null
  >();
  const [selectedItem, setSelectedItem] = useState<Drive | null>();
  const [openShareModal, setOpenShareModal] = useState<boolean>(false);
  const [openTitleEdit, setOpenTitleEdit] = useState(false);
  const [currentTargetId, setCurrentTargetId] = useState<string>('');
  const getSelectedItem = (id: string) => {
    return dataSource.find((item) => item.id === id);
  };
  const getMenuItem = () => [
    {
      text: '名称変更',
      icon: <EditIcon />,
      disabled:
        selectedIds.length > 1 ||
        getSelectedItem(currentTargetId)?.role === SHARE_PERM_DROPDOWN.VIEWER,
      callback: () => {
        handleCloseContextMenu();
        setOpenTitleEdit(true);
      },
    },
    {
      text: 'シェア',
      icon: <ShareIcon />,
      disabled:
        selectedIds.length > 1 ||
        getSelectedItem(currentTargetId)?.role === SHARE_PERM_DROPDOWN.VIEWER,
      callback: () => {
        handleCloseContextMenu();
        setOpenShareModal(true);
      },
    },
  ];

  const [contextMenuItems, setContextMenuItems] = useState<ActionMenuItem[]>(
    getMenuItem()
  );

  useEffect(() => {
    setContextMenuItems([...getMenuItem()]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedIds, currentTargetId]);

  const setValueContextMenu = (
    event: React.MouseEvent,
    currentValue: ContextMenuPosition | null,
    setValue: React.Dispatch<React.SetStateAction<ContextMenuPosition | null>>
  ) => {
    event.preventDefault();
    setValue(
      currentValue === null
        ? {
            mouseX: event.clientX + 2,
            mouseY: event.clientY - 6,
          }
        : null
    );
  };

  const handleContextMenuRow = (event: React.MouseEvent) => {
    if (!contextMenuRow) {
      const id = event.currentTarget.getAttribute('data-id');
      setCurrentTargetId(id || '');
      if (selectedIds.length > 1 && selectedIds.includes(id || '')) {
        handleContextMenuClick();
      } else {
        setSelectedIdContexMenu(id);
        setSelectedItem(getSelectedItem(id || ''));
        id && handleMenuClick(id);
      }
    }
    setValueContextMenu(event, contextMenuRow, setContextMenuRow);
  };

  const handleCloseContextMenu = () => {
    setContextMenuRow(null);
  };

  const handleOpenActionRowMenu = (id: string) => {
    handleCloseContextMenu();
    setSelectedIdContexMenu(id);
    setSelectedItem(getSelectedItem(id || ''));
    handleMenuClick(id);
  };

  const handleTitleUpdate = (title: string) => {
    selectedIdContexMenu && handUpdateTitleChat(selectedIdContexMenu, title);
    setOpenTitleEdit(false);
  };

  const menuRowTable = (role: string) => [
    {
      text: '名称変更',
      icon: <EditIcon />,
      disabled: role === SHARE_PERM_DROPDOWN.VIEWER,
      callback: () => {
        handleCloseContextMenu();
        setOpenTitleEdit(true);
      },
    },
    {
      text: 'シェア',
      icon: <ShareIcon />,
      disabled: role === SHARE_PERM_DROPDOWN.VIEWER,
      callback: () => {
        handleCloseContextMenu();
        setOpenShareModal(true);
      },
    },
  ];

  return (
    <>
      <TableContainer
        sx={{ height: 'calc(100% - 48px)' }}
        component={Paper}
        className="table-container"
      >
        <Table
          stickyHeader
          aria-label="sticky table"
          sx={{
            height: loading ? 'calc(100% - 57px)' : 'auto',
            position: 'relative',
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell>名称</TableCell>
              <TableCell align="center">作成者</TableCell>
              <TableCell align="center">最終更新日</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={4}>
                  <Loading isLoad={loading} style={{ top: '57px' }} />
                </TableCell>
              </TableRow>
            ) : (
              <>
                {dataSource.map((row, index) => {
                  const isItemSelected = selectedIds.indexOf(row.id) !== -1;
                  const labelId = `enhanced-table-checkbox-${index}`;
                  return (
                    <TableRow
                      hover
                      key={index}
                      className="table-row"
                      aria-checked={isItemSelected}
                      selected={isItemSelected}
                      role="checkbox"
                      data-id={row.id}
                      onContextMenu={handleContextMenuRow}
                    >
                      <TableCell
                        component="td"
                        scope="row"
                        sx={{ color: '#4b5563' }}
                      >
                        <div className="col-action">
                          <div className="flex-col">
                            {isItemSelected ? (
                              <Checkbox
                                color="info"
                                onChange={() => handleCheckBoxChange(row.id)}
                                checked={isItemSelected}
                                inputProps={{
                                  'aria-labelledby': labelId,
                                }}
                              />
                            ) : (
                              <Box
                                className="box-icon"
                                onClick={() => handleCheckBoxChange(row.id)}
                              >
                                <SmsIcon></SmsIcon>
                              </Box>
                            )}
                            <Box
                              className="row-name"
                              onClick={() => handleRowClick(row.id)}
                            >
                              {row.title}
                            </Box>
                          </div>
                        </div>
                      </TableCell>
                      <TableCell
                        onClick={() => handleRowClick(row.id)}
                        align="center"
                        sx={{ color: '#4b5563' }}
                      >
                        {row.email}
                      </TableCell>
                      <TableCell
                        onClick={() => handleRowClick(row.id)}
                        align="center"
                        sx={{ color: '#4b5563' }}
                      >
                        {row.updated_at}
                      </TableCell>
                      <TableCell align="center" sx={{ color: '#4b5563' }}>
                        <SelectMenu
                          menuItems={menuRowTable(row?.role || '')}
                          anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                          }}
                          transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                          }}
                          idButton="addNewBtn"
                          idMenu="addNewMenu"
                          textButton={'Add new'}
                          className="btn-add"
                          iconButton={<MoreVertIcon />}
                          onlyIcon={true}
                          onClick={() => handleOpenActionRowMenu(row.id)}
                          isCloseMenu={!!contextMenuRow}
                        />
                      </TableCell>
                      <ContextMenu
                        open={contextMenuRow !== null}
                        handleClose={handleCloseContextMenu}
                        position={contextMenuRow}
                        menuItems={contextMenuItems}
                      />
                    </TableRow>
                  );
                })}
              </>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {selectedItem?.id && (
        <ShareModal
          key={selectedItem.id + 1}
          open={openShareModal}
          title={selectedItem.title}
          onClose={() => setOpenShareModal(false)}
          selectedId={selectedItem.id}
        />
      )}
      {selectedItem?.id && (
        <TitleUpdateDialog
          key={selectedItem.id + 2}
          defaultTitle={selectedItem.title}
          open={openTitleEdit}
          close={() => setOpenTitleEdit(false)}
          handleTitleUpdate={handleTitleUpdate}
        />
      )}
    </>
  );
}
